import { render, staticRenderFns } from "./c_picture_cube.vue?vue&type=template&id=2088a878&scoped=true&"
import script from "./c_picture_cube.vue?vue&type=script&lang=js&"
export * from "./c_picture_cube.vue?vue&type=script&lang=js&"
import style0 from "./c_picture_cube.vue?vue&type=style&index=0&id=2088a878&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088a878",
  null
  
)

export default component.exports